import{hasKey as e}from"./hasKey";export var hasKeyOfType=function(r,o,t){return e(r,o)&&typeof r[o]===t};